import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import cn from 'classnames';
import './Select.scss';

import SelectOption from './SelectOption';

const ShopMySelect = props => {
  const selectedOption =
    props.value && // Not set
    (props.options.find(option => option.value === props.value) || // One level
      _.flatten(_.map(props.options, 'options')).find(option => option.value === props.value)); // Two levels

  const onChange = option => props.onChangeValue(option.value);
  return (
    <>
      <Select
        className={cn('shopmy-select', props.className, { 'with-styling': !props.noStyling, 'on-dark': props.onDark })}
        classNamePrefix='shopmy-select'
        options={props.options}
        value={selectedOption}
        onChange={onChange}
        components={{ Option: SelectOption }}
        placeholder={props.placeholder}
        isSearchable={!props.disableSearch}
      />
    </>
  );
};

ShopMySelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChangeValue: PropTypes.func.isRequired,

  // Optional Functionality
  disableSearch: PropTypes.bool, // To turn off the ability to search filters

  // Optional Styling
  onDark: PropTypes.bool, // To set the select on dark background
  className: PropTypes.string, // To add a class to the select
  noStyling: PropTypes.bool // To turn off the styling
};

export default ShopMySelect;
